import gql from 'graphql-tag';

export const SPECIFICATION_TEMPLATE_FRAGMENT = gql`
  fragment SpecificationTemplateFragment on SpecificationTemplate {
    templateLogoURL
    templateName
    workletSpecKeys
  }
`;
